import { useCallback } from 'react'
import { clearStateForImpersonation } from 'store/organization'
import { baseApi } from 'store/api'
import { useAppDispatch } from 'store/hooks'

export default function useClearImpersonationState(): () => void {
  const dispatch = useAppDispatch()

  return useCallback(async () => {
    await dispatch(clearStateForImpersonation())
    await dispatch(baseApi.util.resetApiState())
  }, [dispatch])
}
